import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Container, 
  Paper, 
  Divider,
  IconButton,
  Grid
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom'; 
import { isInApp } from '../utils/environment';

// 自定义样式组件
const StatusIcon = styled(CheckCircleIcon)(({ theme }) => ({
  fontSize: 72,
  color: '#007AFF',
  marginBottom: theme.spacing(2),
}));  

const InfoRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 0),
}));

const InfoLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '1rem',
}));

const InfoValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '1rem',
  fontWeight: 500,
  textAlign: 'right',
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: 8,
  padding: theme.spacing(1.5),
  fontSize: '1rem',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: '0px 4px 12px rgba(0, 122, 255, 0.2)',
  backgroundColor: '#007AFF',
  '&:hover': {
    backgroundColor: '#0062cc',
  },
}));

const PayBill = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data;
  return (
    <Container 
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      maxWidth="sm" 
      sx={{ 
        height: '100vh', 
        px: 2, 
        display: 'flex', 
        flexDirection: 'column',
        bgcolor: '#fff'
      }}
    >
      
      {/* 导航栏 */}
      {
        !isInApp() && (
          <Box sx={{ py: 2, display: 'flex', alignItems: 'center' }}>
          <IconButton edge="start" sx={{ mr: 2 }}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" component="h1" sx={{ fontWeight: 600, flex: 1, textAlign: 'center' }}>
            Cash Out
          </Typography>
          <Box sx={{ width: 40 }} /> {/* 为了平衡布局 */}
        </Box>
        )
      }
      
      <Divider sx={{ mb: 4 }} />
      
      {/* 成功状态 */}
      <Box 
        component={motion.div}
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        transition={{ type: 'spring', stiffness: 200 }}
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center',
          my: 4 
        }}
      >
        <StatusIcon />
        <Typography variant="h5" component="h2" sx={{ fontWeight: 500, mb: 4 }}>
          Withdraw Successful
        </Typography>
      </Box>
      
      {/* 交易详情 */}
      <Paper 
        elevation={0} 
        sx={{ 
          borderRadius: 2,
          overflow: 'hidden',
          mb: 4,
          bgcolor: 'white'
        }}
      >
        <InfoRow>
          <InfoLabel>Transaction ID</InfoLabel>
          <InfoValue>{data?.withdrawId || ''}</InfoValue>
        </InfoRow>
        <Divider />
        
        <InfoRow>
          <InfoLabel>Amount</InfoLabel>
          <InfoValue>${data?.price || ''}</InfoValue>
        </InfoRow>
        <Divider />
        
        <InfoRow>
          <InfoLabel>Charge</InfoLabel>
          <InfoValue>${data?.feePrice | ''}</InfoValue>
        </InfoRow>
        <Divider />
        
        <InfoRow>
          <InfoLabel>Total</InfoLabel>
          <InfoValue sx={{ fontWeight: 700 }}>${data?.totalPrice || ''}</InfoValue>
        </InfoRow>
        <Divider />
        
        <InfoRow>
          <InfoLabel>Timestamp</InfoLabel>
          <InfoValue>{data?.createTime}</InfoValue>
        </InfoRow>
      </Paper>
      
      {/* 底部按钮 */}
      <Box sx={{ mt: '4'}}>
        <ActionButton 
          fullWidth 
          variant="contained" 
          component={motion.button}
          whileTap={{ scale: 0.98 }}
          onClick={() => navigate('/campaigns/invitations/withdrawal-records')}
        >
          Done
        </ActionButton>
      </Box>
    </Container>
  );
};

export default PayBill;
